import { render, staticRenderFns } from "./HerosAdd.vue?vue&type=template&id=7b7ed77a&scoped=true"
import script from "./HerosAdd.vue?vue&type=script&lang=js"
export * from "./HerosAdd.vue?vue&type=script&lang=js"
import style0 from "./HerosAdd.vue?vue&type=style&index=0&id=7b7ed77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ed77a",
  null
  
)

export default component.exports